module.exports = __webpack_public_path__ + "img/brookhaven-estate.4acb4429.png";